import React from 'react';
import styled from 'styled-components';

import selected from '../img/icons/selected_icon.svg';
import unselected from '../img/icons/unselected_icon.svg';
import address_icon from '../img/icons/352521_location_on_icon.svg';
import email_icon from '../img/icons/3994434_address_at_contact_email_icon.svg';
import phone_icon from '../img/icons/9055353_bxs_phone_call_icon.svg';
import metro7 from '../img/icons/Paris_transit_icons_-_Métro_7.svg';
import metro5 from '../img/icons/Paris_transit_icons_-_Métro_5.svg';
import bus91 from '../img/icons/Logo_Ligne_Bus_RATP_91.svg';

const Infos = () => {
    return(
        <StyledInfos id="infos">
            <div className="open-hours">
                <h2>Horaires d'ouverture</h2>
                <div className="content">
                    <div className="days">
                        <div className="day closed">
                            <img src={unselected} alt="" />
                            <p>Lundi</p>
                        </div>
                        <div className="day">
                            <img src={selected} alt="" />
                            <p>Mardi</p>
                        </div>
                        <div className="day">
                            <img src={selected} alt="" />
                            <p>Mercredi</p>
                        </div>
                        <div className="day">
                            <img src={selected} alt="" />
                            <p>Jeudi</p>
                        </div>
                        <div className="day">
                            <img src={selected} alt="" />
                            <p>Vendredi</p>
                        </div>
                        <div className="day">
                            <img src={selected} alt="" />
                            <p>Samedi</p>
                        </div>
                        <div className="day closed">
                            <img src={unselected} alt="" />
                            <p>Dimanche</p>
                        </div>
                    </div>
                    <div className="hours">
                        <p className='closed'>Fermé</p>
                        <p>10:00 - 19:00</p>
                        <p>10:00 - 19:00</p>
                        <p>10:00 - 19:00</p>
                        <p>10:00 - 19:00</p>
                        <p>10:00 - 19:00</p>
                        <p className='closed'>Fermé</p>
                    </div>
                </div>
            </div>
            
            <div className="location">
                <h2>Où trouver le salon?</h2>
                <div className="address">
                    <img src={address_icon} alt="" />
                    <p>61 Boulevard Saint-Marcel, 75013 Paris</p>
                </div>
                <div className="acces">
                    <div className="metro">
                        <div className="container">
                            <img src={metro7} alt="" />
                            <p>Les Gobelins</p>
                        </div>
                        <div className="container">
                            <img src={metro5} alt="" />
                            <p>Saint-Marcel</p>
                        </div>
                    </div>
                    <div className="bus container">
                        <img src={bus91} alt="" />
                        <p>St-Marcel/Jeanne d'arc ou Les Gobelins</p>
                    </div>
                </div>


                <div className="telephone">
                    <img src={phone_icon} alt="" />
                    <p>01.47.07.24.90</p>
                </div>

                <div className="mail">
                    <img src={email_icon} alt="" />
                    <p>salonnicolasd@gmail.com</p>
                </div>
            </div>

            <div className="maps">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2626.185436028449!2d2.3533737!3d48.8356015!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e671960838a90b%3A0xd802f69c01234f3e!2snicolas%20d!5e0!3m2!1sfr!2sfr!4v1741011516634!5m2!1sfr!2sfr"
                    width="400" height="300" style={{border:0}} allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
        </StyledInfos>
    )
}

const StyledInfos = styled.section`
    padding: 5rem 10rem;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: start;
    line-height: 1.5rem;

    h2{
        padding-bottom: 1rem;
    }
    p{
        font-size: 1rem;
    }

    .content{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }
    img{
        width: 12px;
    }
    .hours{
        text-align: right;
    }
    .day{
        display: flex;
        p{
            padding-left: 1rem;
        }
    }
    .closed{
        color: rgb(99, 99, 99)
    }

    .location{
        img{
            width: 16px;
            margin-right: 1rem;
        }
    }
    .address, .telephone, .mail{
        display: flex;
        flex-direction: row;
    }
    .acces{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        margin: 1rem 0rem;
    }
    .container{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
    .metro, .bus{
        flex: 1 1 40%;
    }

    @media (max-width: 768px){
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 5rem 3rem;

        .open-hours{
            width: 100%;
            padding-bottom: 4rem;
        }
        .maps{
            display: none;
        }
    }
`

export default Infos;